import { Molecule } from "AppReact";
import styled from "styled-components";
import { Icon, PrimaryTextSm, RedTextSm } from "atoms";
import { CopyOutlineSvg, GreenTickSvg, LoadingDotsSvg, ErrorSvg } from "components/icons";

const template = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export default Molecule({
  template,
  type: "button",
  atoms: [
    {
      component: Icon,
      name: "Icon",
      displayValue: ({ linkCopied, isLoading, isError, isProcessing }) => {
        if (isError) {
          return ErrorSvg({});
        }

        if (isLoading || isProcessing) {
          return LoadingDotsSvg({
            color: window?.settings?.primary_color ?? "#1DBD6B",
          });
        }
        
        if (linkCopied) {
          return GreenTickSvg({});
        }

        return CopyOutlineSvg({
          width: 14,
          height: 14,
          color: window?.settings?.primary_color ?? "#1DBD6B",
        });
      },
    },
    {
      component: PrimaryTextSm,
      name: "Label",
      renderIf: ({ label, isLoading, isError, isProcessing }) => !!label && !isLoading && !isProcessing && !isError,
      displayValue: ({ label, linkCopiedStateText, linkCopied }) =>
        linkCopied ?  linkCopiedStateText: label,
    },
    {
      component: PrimaryTextSm,
      name: "Label",
      renderIf: ({ label, isLoading }) => isLoading && !!label,
      displayValue: ({ label }) => label,
    },
    {
      component: PrimaryTextSm,
      name: "Label",
      renderIf: ({ label, isProcessing }) => isProcessing && !!label,
      displayValue: ({ label }) => label,
    },
    {
      component: RedTextSm,
      name: "Label",
      renderIf: ({ label, isError }) => isError && !!label,
      displayValue: ({ label }) => label,
    }
  ],
});
